<template>
  <div>
    <div
      v-if="relativeAssociateObj.relatives.length || relativeAssociateObj.associates.length"
      class="px-2 mx-1 border pt-0 pb-3"
    >
      <div class="mt-1 ml-1">
        <BaseELabel label="Relatives" class="mb-2" new-style />
      </div>
      <div
        v-if="relativeAssociateObj.relatives.length"
      >
        <div class="row mx-1" :class="$style.relativesBlock">
          <div
            v-for="(item, index) in relativeAssociateObj.relatives"
            :key="index"
            :class="$style.relativesContainer"
            class="border col-md-6"
          >
            <b-row>
              <b-col md="7" :class="$style.status">
                <strong>Name: </strong><span>{{ formatDisplay(item.name) }}</span>
              </b-col>
              <b-col md="5" class="p-0" :class="$style.status">
                <strong>Date of Death: </strong><span>{{ formatDisplay(item.dateOfDeath) }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7" :class="$style.status">
                <strong>Date of Birth: </strong><span>{{ formatDisplay(item.dateOfBirth) }}</span>
              </b-col>
              <b-col md="5" class="p-0" :class="$style.status">
                <strong>Death Location: </strong><span>{{ formatDisplay(item.deathLoaction.trim()) }}</span>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

      <NoRecordFound v-else></NoRecordFound>

      <div class="mt-2 ml-1">
        <BaseELabel label="Associates" class="mb-2" new-style />
      </div>
      <div v-if="relativeAssociateObj.associates.length" class="mt-1">
        <div class="row mx-1" :class="$style.relativesBlock">
          <div
            v-for="(item, index) in relativeAssociateObj.associates"
            :key="index"
            :class="$style.relativesContainer"
            class="border col-md-6"
          >
            <b-row>
              <b-col md="7" :class="$style.status">
                <strong>Name: </strong><span>{{ formatDisplay(item.name) }}</span>
              </b-col>
              <b-col md="5" class="p-0" :class="$style.status">
                <strong>Date of Death: </strong><span>{{ formatDisplay(item.dateOfDeath) }}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7" :class="$style.status">
                <strong>Date of Birth: </strong><span>{{ formatDisplay(item.dateOfBirth) }}</span>
              </b-col>
              <b-col md="5" class="p-0" :class="$style.status">
                <strong>Death Location: </strong><span>{{ formatDisplay(item.deathLoaction.trim()) }}</span>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <NoRecordFound v-else></NoRecordFound>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    relativesData: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      relativeFields: [
        {
          key: 'ssn',
          label: 'SSN',
        },
        {
          key: 'companyName',
          label: 'Company Name',
        },
        {
          key: 'address',
          label: 'Address',
        },
        {
          key: 'taxId',
          label: 'Tax ID',
        },
      ],
      associateFields: [
        {
          key: 'name',
          label: 'Name',
        },
        {
          key: 'address',
          label: 'Address',
        },
      ],
    }
  },
  computed: {
    relativeAssociateObj() {
      return this.relativesData
    },
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
// .border {
//   // border: 1px solid black;
//   border: 1px solid #777676;
// }
.status {
  font-size: $size-content-font;
  color: $color-text-gray;
}
// .label {
//   margin: 0.625rem 0;
//   font-size: $size-content-font;
//   font-weight: $label-font-weight;
//   color: $color-text-gray;
// }
.relativesContainer {
  padding: 5px 10px;
  font-size: 13px;
  // border: 1px solid #6d6e70;
}
//   .relativesContainer:nth-child(odd) {
//     background: #fff !important;
//   }
// .relativesContainer:nth-child(even) {
//   background: #eee;
// }
.relativesContainer:nth-child(4n+3), .relativesContainer:nth-child(4n+4){
    background: #eee;
}
.tableHeading {
  font-weight: 600;
  color: #000;
}
</style>
